import axios from 'axios'
import { toast } from 'react-toastify';
import { clearStorage } from '../service/utilService';
import { signout } from './apiService';

import { apiEndPoint } from '../config';
const { ssoUrl } = apiEndPoint;

axios.interceptors.request.use(req => {
    req.withCredentials = true;
    return req;
},
    error => {
        return Promise.reject(error);
    })
    
axios.interceptors.response.use(res => {
    if (res.status === 200) {
        if (!res.config.url.includes("/auth/refresh/token") && !res.config.url.includes("/api/auth/logout") && !res.config.url.includes("/api/auth/signin")) {
            const Http = new XMLHttpRequest();
            Http.open('GET', ssoUrl+'/ssoSessionAlive', true);
            Http.withCredentials = true;
            Http.send(null);
            Http.onreadystatechange = (e) => {
                if (Http.readyState === 4)
                if (Http.status === 200) {
                    try {
                        const data = JSON.parse(Http.responseText || "{}");
                        if (data.responseMsg !== "Valid session") {
                            window.location.href = "/";
                        }
                    } catch (e) {
                        window.location.href = ssoUrl + "/login";
                    }
                } else if (Http.status === 403) {
                    window.location.href = ssoUrl + "/login";
                }
            }
        }
    }
    return res;
},
    error => {
        if (window.location.pathname !== "/")
            if (error?.response?.status === 401) {
                toast.warning("Unauthorized access!");
                clearStorage();
                signout().then(() => {
                     goToLogin();
                }).catch(() => {
                     goToLogin();
                });
            }

        return Promise.reject(error);
    })

    const goToLogin = ()=> {
        setTimeout(() => {
            window.location.href = "/";
        }, 3000);
    }

export const http = {
    get: axios.get,
    put: axios.put,
    post: axios.post,
}